import { Edit } from "@mui/icons-material";
import { Box, Button, IconButton, Typography } from "@mui/material";
import {
  exportTanInvalid,
  getTraceClientVerification,
} from "api/services/automation/dashboard-tan";
import Table from "components/Table";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { ResType } from "types";
import CredentialsEdit from "./CreadentialEdit";
import SearchContainer from "components/SearchContainer";
import { handleError } from "utils/handleError";
import { snack } from "components/toast";
import { getCurrentFormattedDateTime } from "utils";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

const TracesInvalidate = (tab) => {
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [search, setSearch] = useState("");
  const { data, isLoading }: ResType = useQuery(
    ["invalidate-check", { search: search, limit: pageCount, offset: page * pageCount }],
    getTraceClientVerification,
    {
      onSuccess(res: any) {
        setTotalCount(res?.data?.totalCount);
      },
    }
  );

  const handleSearch = (e) => {
    setSearch(e);
    setPage(0);
  };

  const { mutate: mutate1 } = useMutation(exportTanInvalid, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      const formattedDateTime = getCurrentFormattedDateTime();

      let link = document.createElement("a");
      link.href = file;
      link.download = `ATOM Pro - Tan Invalid Credentials ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Exported Successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });

  const handleExport = () => {
    const data = { search: search, limit: pageCount, offset: page * pageCount };
    mutate1(data);
  };

  return (
    <Box m={1}>
      <Box display="flex" justifyContent="space-between">
        <SearchContainer
          minWidth="300px"
          value={search}
          debounced
          placeHolder="Search by  Name | TAN"
          onChange={handleSearch}
        />
        <Button
          variant="outlined"
          sx={{ marginRight: "20px", marginBottom: "10px" }}
          color="secondary"
          onClick={handleExport}
          startIcon={<FileDownloadOutlinedIcon />}
        >
          Export
        </Button>
      </Box>

      <Table
        sx={{ height: "76vh", mt: 1 }}
        pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
        data={data?.data?.filteredRows || []}
        columns={columns}
        loading={isLoading}
        // selection={{ selected, setSelected }}
      />
    </Box>
  );
};

const Actions = (props: any) => {
  const [state, setState] = useState(props?.data?.tanCredentials);
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <Box display="flex" gap={1}>
        <>
          <IconButton onClick={(e) => setOpen(true)}>
            <Edit />
          </IconButton>
        </>
      </Box>
      <CredentialsEdit open={open} setOpen={setOpen} data={props?.data} />
    </>
  );
};

let columns = [
  {
    key: "Category",
    title: "Category",
    render: (v) => {
      return <Typography>{v?.client?.category}</Typography>;
    },
  },
  {
    key: "id",
    title: "Client Name",
    render: (rowData: any) => <Typography>{rowData?.client?.displayName}</Typography>,
  },
  {
    key: "id",
    title: "Client ID",
    render: (rowData: any) => <Typography>{rowData?.client?.clientId}</Typography>,
  },
  {
    key: "tanNumber",
    title: "TAN",
  },
  {
    key: "traceRemarks",
    title: "Remarks",
  },
  {
    key: "id",
    title: "Actions",
    render: (rowData: any) => <Actions data={rowData} />,
  },
];

export default TracesInvalidate;
